import { render, staticRenderFns } from "./joinNow.vue?vue&type=template&id=4d206298&scoped=true"
import script from "./joinNow.vue?vue&type=script&lang=js"
export * from "./joinNow.vue?vue&type=script&lang=js"
import style0 from "./joinNow.vue?vue&type=style&index=0&id=4d206298&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d206298",
  null
  
)

export default component.exports